// @core/api/endpoints/workflow/get_execution_logs.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetExecutionLogsResponse,
} from '../../../types/workflow';

const BASE_PATH = '/workflow';

/**
 * Get execution logs
 * Returns debug and audit log entries for a pipeline execution. Optionally filter by node ID and log level.
 */
export async function GetExecutionLogs(
  execution_id: string,
  options?: RequestOptions
): Promise<GetExecutionLogsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/workflows/executions/:execution_id/logs`;
  requestPath = requestPath.replace(':execution_id', encodeURIComponent(execution_id));
  const requestOptions = options;
  return client.get<GetExecutionLogsResponse>(requestPath, { ...requestOptions });
}
